import type { ViewStyle } from 'react-native';
import { Platform } from 'react-native';
import Dimens from 'src/core/utils/Dimens';
import Colors from 'src/core/utils/Colors';
import Constants from 'src/core/utils/Constants';

const baseHeight = Platform.OS === Constants.platformWeb ? Dimens.tabBarHeightWeb75 : Dimens.tabBarHeight60;

// Padding the inset alone leaves the labels ending flush against the system navigation bar.
const systemNavigationGap = Dimens.padding8;

export const tabBarStyle: ViewStyle = {
	shadowOffset: {
		width: Dimens.size0,
		height: Dimens.size0,
	},
	shadowOpacity: Dimens.opacity10,
	shadowRadius: Dimens.size30,
	elevation: Dimens.elevation24,
	borderTopWidth: Dimens.size0,
	backgroundColor: Colors.white,
	position: 'absolute',
	bottom: Dimens.padding0,
	paddingTop: Dimens.padding10,
	width: '100%',
	height: baseHeight,
	zIndex: Dimens.zIndexBase,
};

export const hiddenTabBarStyle: ViewStyle = { display: 'none' };

export const tabBarBottomInset = (bottomInset: number): number =>
	bottomInset > Dimens.size0 ? bottomInset + systemNavigationGap : bottomInset;

export const tabBarHeight = (bottomInset: number): number => baseHeight + tabBarBottomInset(bottomInset);

export const tabBarStyleWithInset = (bottomInset: number): ViewStyle => ({
	...tabBarStyle,
	paddingBottom: tabBarBottomInset(bottomInset),
	height: tabBarHeight(bottomInset),
});
